import { Layout as FlexLayout, Model } from "flexlayout-react";
import { createContext, useContext } from "react";

type PanelProps = {
  panelId: string;
};

export type PanelConfig = {
  component: React.ComponentType<PanelProps>;
  name: string;
  enableMaximize?: boolean;
  enableHeader?: boolean;
  minWidth?: number;
  maxWidth?: number;
  minHeight?: number;
  maxHeight?: number;
};

export type Config = Record<string, PanelConfig>;

export type Option = {
  id: string;
  name: string;
  isDisabled: boolean;
};

type ActiveLayoutContextType = {
  model: Model;
  addPanel: (id: string, nodeId: string) => void;
  config: Config;
  options: Option[];
  onDragAdd: (ev: DragEvent, configId: string) => void;
  layoutRef: React.RefObject<FlexLayout | null>;
  onModelChange: (m: Model) => void;
};

export const ActiveLayoutContext = createContext<
  ActiveLayoutContextType | undefined
>(undefined);

export const useActiveLayout = () => {
  const context = useContext(ActiveLayoutContext);
  if (context === undefined) {
    throw new Error(
      "useActiveLayout must be used within a ActiveLayoutProvider"
    );
  }
  return context;
};
